import React, { useState } from 'react';
import {
  email,
  Login,
  required,
  TextInput,
  useTranslate,
  useNotify,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { apiPost } from '../brainApi';

const useStyles = makeStyles(
  (theme) => ({
    form: {
      padding: '0 1em 1em 1em',
    },
    input: {
      width: '100%',
    },
    button: {
      width: '100%',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    backButton: {
      width: '100%',
      textAlign: 'center',
      fontSize: '0.75rem',
      marginTop: '2px',
      marginBottom: '8px',
    },
  }),
  { name: 'RaLoginForm' },
);

const ForgotPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const classes = useStyles(props);
  const translate = useTranslate();
  const notify = useNotify();

  const submit = (values) => {
    setLoading(true);

    const payload = { email: values.email, source: 'admin' };
    apiPost('/send-reset-link', payload, true).then(({ Status, Message }) => {
      setLoading(false);
      if (Status === 'Success') {
        setMessage(
          `An email has been sent to ${values.email} containing further instructions.`,
        );
      } else {
        notify(Message, 'warning');
      }
    });
  };

  const form = (
    <Form
      onSubmit={submit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className={classes.form}>
            <TextInput
              autoFocus
              className={classes.input}
              source="email"
              validate={[required(), email()]}
            />
          </div>
          <CardActions>
            <Button
              variant="contained"
              type="submit"
              color="primary"
              disabled={loading}
              className={classes.button}
            >
              {loading && (
                <CircularProgress
                  className={classes.icon}
                  size={18}
                  thickness={2}
                />
              )}
              {translate('auth.submit')}
            </Button>
          </CardActions>
        </form>
      )}
    />
  );

  return (
    <Login>
      {message ? <div className={classes.form}>{message}</div> : form}
      <div className={classes.backButton}>
        <a style={{ color: 'gray' }} href="/#/login">
          {translate('auth.back_to_login')}
        </a>
      </div>
    </Login>
  );
};

export default ForgotPassword;
